/*--------------------
* Portfolio Logo Marquee
----------------------*/
const BRANDS = [
  { name: "Hit My Macros", icon: "img/brands/hmm-logo.png" },
  { name: "Telephant", icon: "img/brands/telephant-logo.png" },
  { name: "Marketing Dwarf", icon: "img/brands/marketingdwarf-logo.png" },
  { name: "JobHunterGPT", icon: "img/brands/jobhuntergpt-logo.png" },
  { name: "StockNews", icon: "img/brands/stocknews-logo.png" },
  { name: "Yolk", icon: "img/brands/yolk-logo.png" },
  { name: "JMS", icon: "img/brands/jms-logo.png" },
];

function BrandItem({ name, icon }) {
  return (
    <div className="flex items-center gap-3 px-8 shrink-0 opacity-60 hover:opacity-100 transition-opacity duration-300">
      <img src={icon} alt={name} title={name} className="h-[34px] w-auto" />
      <span className="font-mono text-[13px] tracking-[1px] text-mist-300 whitespace-nowrap">
        {name}
      </span>
    </div>
  );
}

export default function BrandSlider() {
  return (
    <div className="bg-night-900 border-y border-white/[0.05] py-8 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {[...BRANDS, ...BRANDS].map((brand, i) => (
          <BrandItem key={i} name={brand.name} icon={brand.icon} />
        ))}
      </div>
    </div>
  );
}
